import { z } from '../zod';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';

const pageIdParam = ObjectIdStringValidationSchema.openapi({
  description: 'The unique identifier of the page.',
  example: '507f1f77bcf86cd799439011',
});

const ticketGroupIdParam = ObjectIdStringValidationSchema.openapi({
  description: 'The unique identifier of the ticket group.',
  example: '507f1f77bcf86cd799439012',
});

const ticketTypeIdParam = ObjectIdStringValidationSchema.openapi({
  description: 'The unique identifier of the ticket type.',
  example: '507f1f77bcf86cd799439013',
});

export const TicketGroupPathParamsValidationSchema = z.object({
  pageId: pageIdParam,
  ticketGroupId: ticketGroupIdParam,
});

export const TicketTypePathParamsValidationSchema = z.object({
  pageId: pageIdParam,
  ticketGroupId: ticketGroupIdParam,
  ticketTypeId: ticketTypeIdParam,
});

export const TicketTypeEventIdInputSchema = ObjectIdStringValidationSchema.meta({
  description:
    'The ID of the event. Event IDs come from list_events, or the `id` that create_event returns.',
});

export const TicketTypeIdInputSchema = ObjectIdStringValidationSchema.meta({
  description:
    "The ID of the ticket type. get_event lists each group's ticket types under `ticketGroups[].ticketTypes[].id`.",
});

export const TICKET_TYPE_IMAGE_ID_DESCRIPTION =
  'ID of an image file for the ticket type, uploaded with `upload_file` (purpose `image`).';

export const TICKET_TYPE_TRIGGER_ID_DESCRIPTION =
  'ID of another ticket type on the same event whose sale end or sell-out makes this one available. Required when `availabilityBehavior` is `after_ticket_sale_ends`, `after_ticket_sold_out` or `after_ticket_ends_or_sold_out`. Find it under `ticketGroups[].ticketTypes[].id` in get_event.';
